import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_DELETE_DELETETAG } from "../../store/deleteTag/deleteTagAction";
import { useDeleteTags } from "../../store/deleteTag/reducer";
interface Props {
  deletetag: any;
  isOpen: any;
  onClose: any;
}
const DeleteTagPerDelete: React.FC<Props> = ({
  isOpen,
  onClose,
  deletetag,
}) => {
  const dispatch = useDispatch();
  const { deletetags, busy, message } = useDeleteTags();
  const { _id } = deletetag;
  const toast = useToast();

  useEffect(() => {
    const findLink = deletetags.find(
      (val: Record<string, any>) => val._id === _id
    );
    if (!findLink) {
      toast({
        title: "Permenant Deleted",
        description: "Tag is successfully permenant deleted.",
        status: "info",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [_id, deletetags, onClose, toast]);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Permenant Delete Tag</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to permenant delete tag?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_DELETETAG,
                payload: { _id: deletetag._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>{" "}
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
export default DeleteTagPerDelete;
